export const PERMISSION = {
  MLA_EDIT: 67,
  MLA_VIEW: 68
} as const;

export type PermissionCode = typeof PERMISSION[keyof typeof PERMISSION];

/** {"isAdmin":true,"permissions":[]} | {"isAdmin":false,"permissions":[67,68]} */
/** {"status_code":404,"message":"NOT_FOUND","errors":null} */
export type AdminPermissions = {
  isAdmin: boolean;
  permissions: number[];
};

export type AdminPermissionsNotFoundResponse = {
  status_code: number;
  message: string;
  errors: null;
};

export type AdminPermissionsApiResponse =
  | AdminPermissions
  | AdminPermissionsNotFoundResponse;

const isAdminPermissionsResponse = (
  response: AdminPermissionsApiResponse
): response is AdminPermissions => (
  'isAdmin' in response && 'permissions' in response
);

export const normalizeAdminPermissions = (
  response: AdminPermissionsApiResponse | null | undefined
): AdminPermissions | null => {
  if (!response) return null;
  if (!isAdminPermissionsResponse(response)) return null;

  return response;
};

export const hasOneOfPermissions = (
  hasPermission: (code: number) => boolean,
  codes: number[]
): boolean => codes.some(hasPermission);
